import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  Text,
  Box,
  Avatar,
  Table,
  createStyles,
  ActionIcon,
  ScrollArea,
  Flex,
} from "@mantine/core";
import TableLoader from "../../../components/TableLoader";
import Cuations from "./Cuations";
import { useSelector } from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { getMar } from "../../../services";
import moment from "moment";
import { decrypt } from "../../../utils";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import defaultImage from "./../../../images/personal2.png";
import { getAllSignatures } from "../../../services/signature";

// const SignatureInitialsImage = ({ url, isPDF }) => {
//   const [src, setSrc] = useState(null);

//   useEffect(() => {
//     let mounted = true;

//     if (!url) {
//       setSrc(null);
//       return;
//     }

//     if (url.startsWith("http")) {
//       // Remote URL → convert to base64
//       const convertToBase64 = async () => {
//         try {
//           const res = await fetch(url);
//           const blob = await res.blob();
//           const reader = new FileReader();
//           reader.onloadend = () => {
//             if (mounted) setSrc(reader.result);
//           };
//           reader.readAsDataURL(blob);
//         } catch (err) {
//           console.error("Image fetch/convert failed", err);
//           if (mounted) setSrc(null);
//         }
//       };
//       convertToBase64();
//     } else {
//       // Already base64
//       setSrc(url);
//     }

//     return () => {
//       mounted = false;
//     };
//   }, [url]);

//   return (
//     <img
//       src={src}
//       alt="initials-img"
//       width={"100%"}
//       height="auto"
//       style={{
//         // display: "block",
//         // objectFit: "cover",
//          width: isPDF ? "100%" : "100px",
//         // height: "auto",
//            display: "block",
//      height: isPDF ? "20px" : "auto",
//     transform: isPDF ? "scale(2)" : "scale(1)",
//     // width: "auto",
//     // maxWidth: "100%",
//     objectFit: "contain",
//       }}
//     />
//   );
// };

const SignatureInitialsImage = ({ url, isPDF, item }) => {
  const [src, setSrc] = useState(null);
  // Helper to invert image in canvas
  const invertImage = (imageSrc) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = imageSrc;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        for (let i = 0; i < imgData.data.length; i += 4) {
          imgData.data[i] = 255 - imgData.data[i];     // R
          imgData.data[i + 1] = 255 - imgData.data[i + 1]; // G
          imgData.data[i + 2] = 255 - imgData.data[i + 2]; // B
        }
        ctx.putImageData(imgData, 0, 0);
        resolve(canvas.toDataURL());
      };
      img.onerror = () => resolve(imageSrc); // fallback
    });
  };
  useEffect(() => {
    let mounted = true;
    if (!url) {
      setSrc(null);
      return;
    }
    const processImage = async (imageUrl) => {
      let base64Url = imageUrl;
      // Convert remote URL to base64
      if (imageUrl.startsWith("http")) {
        try {
          const res = await fetch(imageUrl);
          const blob = await res.blob();
          const reader = new FileReader();
          reader.onloadend = () => {
            if (!mounted) return;
            base64Url = reader.result;
            // Apply inversion for PDF only
            if (isPDF && item?.medicationType === "Out of Medication") {
              invertImage(base64Url).then((inverted) => {
                if (mounted) setSrc(inverted);
              });
            } else {
              setSrc(base64Url);
            }
          };
          reader.readAsDataURL(blob);
        } catch (err) {
          console.error("Image fetch/convert failed", err);
          if (mounted) setSrc(null);
        }
      } else {
        // Already base64
        if (isPDF && item?.medicationType === "Out of Medication") {
          const inverted = await invertImage(base64Url);
          if (mounted) setSrc(inverted);
        } else {
          setSrc(base64Url);
        }
      }
    };
    processImage(url);
    return () => {
      mounted = false;
    };
  }, [url, isPDF, item?.medicationType]);
  return (
    <img
      src={src}
      alt="initials-img"
      style={{
        width: isPDF ? "100%" : "100px",
        height: isPDF ? "20px" : "auto",
        display: "block",
        transform: isPDF ? "scale(2)" : "scale(1)",
        objectFit: "contain",
        // Only apply browser filter if not PDF
        ...(item?.medicationType === "Out of Medication" && !isPDF && {
          filter: "invert(100%)",
        }),
      }}
    />
  );
};



const MarViewReportModal = ({
  opened,
  onClose,
  selectedClient,
  monthValue,
}) => {
  const { classes } = useStyles();
  const { mar: appointments, loading } = useSelector((state) => state.mar);
  const [marTableData, setMarTableData] = useState([]);
  const image = decrypt(selectedClient?.imageurl);
  const [pdfLoading, setPDFLoading] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const { allSignature } = useSelector((state) => state?.signature);
  const { profile } = useSelector((state) => state?.profile);

  useEffect(() => {
    let tempStaffList = [];
    let _staffList = [];
    marTableData?.map((_m) => {
      _m?.data?.map((_d) => {
        let notNullMed = _d?.appointment?.filter((item) => item !== null);

        notNullMed?.map((item) => {
          if (item?.staff && item?.medicationType?.toLowerCase() !== "missed") {
            let splittedName = item?.staff?.name?.split(" ");
            if (splittedName?.[1]) {
              tempStaffList.push({
                name: item?.staff?.name,
                initial: splittedName[0]?.[0] + splittedName[1]?.[0],
                id: item?.staff?.id,
              });
            } else {
              tempStaffList.push({
                name: item?.staff?.name,
                initial: splittedName[0]?.[0],
                id: item?.staff?.id,
              });
            }
          } else {
            return "-";
          }
        });

        tempStaffList = tempStaffList.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t?.name === item?.name)
        );

        _staffList = tempStaffList;

        tempStaffList?.map((_s) => {
          const staffIndex = staffList.findIndex((v) => v?.name === _s?.name);

          if (staffIndex !== -1) {
            _staffList?.filter((v) => v?.name !== _s?.name);
          }
        });
      });
    });

    setStaffList(_staffList);
  }, [marTableData]);

  const today = new Date();
  const formattedDate = `${
    today.getMonth() + 1
  }-${today.getDate()}-${today.getFullYear()}`;
  const reportName = `${formattedDate}_eMAR_Report`;

  // const start = moment(monthValue?.[0]).startOf("month");
  const start = moment(monthValue?.[0])
    // .subtract(1, "day")
    .clone()
    .startOf("day");
  // const end = moment(monthValue?.[1]).endOf("month");
  let end;
  if (
    moment(monthValue?.[0])?.format("MMM") ==
    moment(monthValue?.[monthValue?.length - 1])?.format("MMM")
  ) {
    end = moment(monthValue?.[monthValue?.length - 1])
      .add(1, "M")
      // .add(1, "day")
      .clone()
      .startOf("day");
  } else {
    end = moment(monthValue?.[monthValue?.length - 1])
      .endOf("month")
      // .add(1, "day")
      .clone()
      .startOf("day");
  }

  const datesArray = [];
  let currentDate = start;

  if (
    moment(monthValue?.[0])?.format("MMM") ==
    moment(monthValue?.[monthValue?.length - 1])?.format("MMM")
  ) {
    while (currentDate < end) {
      datesArray.push(currentDate.clone());
      currentDate.add(1, "day");
    }
  } else {
    while (currentDate <= end) {
      datesArray.push(currentDate.clone());
      currentDate.add(1, "day");
    }
  }

  const daysArray = datesArray.map((date) => date.format("ddd"));

  // useEffect(() => {
  //   if (opened) {
  //     getMar(
  //       `monthly_${monthValue[0].toISOString()}_${monthValue[1].toISOString()}`,
  //       selectedClient
  //     );
  //   }
  // }, [opened]);

  useEffect(() => {
    if (opened) {
      if (
        moment(monthValue?.[0])?.format("MMM") ==
        moment(monthValue?.[monthValue?.length - 1])?.format("MMM")
      ) {
        let endVal = moment(monthValue?.[monthValue?.length - 1]).add(1, "M");
        getMar(`monthly_${monthValue[0]}_${endVal}`, selectedClient?.id);
      } else {
        let endVal = moment(monthValue?.[monthValue?.length - 1]).endOf(
          "month"
        );
        getMar(`monthly_${monthValue[0]}_${endVal}`, selectedClient?.id);
      }
    }
  }, [opened]);

  const isTimeInSlot = (timeToCheck, slot) => {
    const format = "hA"; // Time format, e.g. "6AM"

    // for (let slot of slots) {
    const [start, end] = slot.split(" - ").map((time) => moment(time, format));
    const formattedTime = moment(timeToCheck, "h:mm A");

    // Adjust for the cross-midnight slots like "10PM - 2AM"
    if (end.isBefore(start)) {
      // For slots that span midnight, check in two parts
      if (
        (formattedTime.isSameOrAfter(start) &&
          formattedTime.isBefore(moment("11:59:59 PM", "h:mm A"))) ||
        (formattedTime.isSameOrAfter(moment("12:00 AM", "h:mm A")) &&
          formattedTime.isBefore(end))
      ) {
        // return true;
        return { time: timeToCheck, slot };
      }
    } else {
      // For normal slots
      if (formattedTime.isSameOrAfter(start) && formattedTime.isBefore(end)) {
        // return true;
        return { time: timeToCheck, slot };
      }
    }
    // }

    return false;
  };

  useEffect(() => {
    if (opened && appointments?.length) {
      let medicines = [];
      appointments?.map((appointment) => {
        if (
          medicines?.filter((item) => item?.id == appointment?.form3?.id)
            ?.length === 0
        ) {
          medicines?.push({
            id: appointment?.form3?.id,
            name: appointment?.form3?.medicationName,
            dosage: appointment?.form3?.dosage,
            unit: appointment?.form3?.unit,
            ingestionMode: appointment?.form3?.ingestionMode,
            instruction: appointment?.form3?.medicationInstruction,
          });
        }
      });

      const slots = [
        "6AM - 10AM",
        "10AM - 2PM",
        "2PM - 6PM",
        "6PM - 10PM",
        "10PM - 2AM",
        "2AM - 6AM",
      ];

      let tempTableData = [];
      medicines?.map((medicine) => {
        let medicineAppointment = appointments?.filter(
          (item) => item?.form3?.id == medicine?.id
        );
        datesArray?.map((date) => {
          let singleDayAppointments = medicineAppointment?.filter(
            (item) =>
              moment(item?.date).format("YYYY-MM-DD") ==
              moment(date).format("YYYY-MM-DD")
          );
          if (singleDayAppointments?.length) {
            // Check if there are any PRN medications in the appointments
            const hasPRNMedications = singleDayAppointments?.filter(
              (appointment) =>
                appointment?.medicationType === "PRN" ||
                appointment?.form3?.medicationType === "PRN"
            );

            if (hasPRNMedications?.length) {
              // Function to find the slot based on hour
              function findSlot(hour) {
                if (hour >= 6 && hour < 10) return "6AM - 10AM";
                if (hour >= 10 && hour < 14) return "10AM - 2PM";
                if (hour >= 14 && hour < 18) return "2PM - 6PM";
                if (hour >= 18 && hour < 22) return "6PM - 10PM";
                if (hour >= 22 || hour < 2) return "10PM - 2AM";
                if (hour >= 2 && hour < 6) return "2AM - 6AM";
              }
              // Process each PRN appointment
              singleDayAppointments
                ?.filter(
                  (appointment) => appointment?.form3?.medicationType === "PRN"
                )
                ?.forEach((appointment) => {
                  if (appointment?.date) {
                    // Extract hour from the appointment date
                    const medicineDate = new Date(appointment.date);
                    const hour = medicineDate.getHours();

                    const takenSlot = findSlot(hour);

                    const minutes = medicineDate.getMinutes();

                    // Format time as HH:MM AM/PM
                    const timeSlot = medicineDate.toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    });

                    // Add to table data
                                    console.log('&&&medicine',appointment)

                    tempTableData.push({
                      medicine: appointment?.form3?.medicationName,
                      medicationId: appointment?.form3?.id,
                      slot: takenSlot,
                      appointment: [{ ...appointment, timeSlot }],
                      date: moment(appointment.date).format("MM-DD-YYYY"),
                    });
                  }
                });
            } else {
              singleDayAppointments?.map((dayAppointment) => {
                //  dayAppointment?.form3?.timeSlots?.map((appointmentSlots) => {
                const appointmentSlots = dayAppointment?.timeSlot;
                if (appointmentSlots) {
                  slots?.forEach((slot) => {
                    let timeInSlot = isTimeInSlot(appointmentSlots, slot);
                    if (!timeInSlot) {
                      let sameMedicineInSlotIndex = tempTableData?.findIndex(
                        (tempItem) =>
                          tempItem?.medicationId == medicine?.id &&
                          tempItem?.slot == slot &&
                          tempItem?.date == moment(date).format("MM-DD-YYYY")
                      );

                      if (sameMedicineInSlotIndex == -1) {
                        tempTableData.push({
                          medicine: medicine?.name,
                          medicationId: medicine?.id,
                          slot: slot,
                          appointment: [null],
                          date: moment(date).format("MM-DD-YYYY"),
                        });
                      }
                    } else {
                      let sameMedicineInSlotIndex = tempTableData?.findIndex(
                        (tempItem) =>
                          tempItem?.medicationId == medicine?.id &&
                          tempItem?.slot == slot &&
                          tempItem?.date == moment(date).format("MM-DD-YYYY")
                      );

                      if (sameMedicineInSlotIndex !== -1) {
                        tempTableData[sameMedicineInSlotIndex] = {
                          medicine: medicine?.name,
                          slot: slot,
                          // appointment: dayAppointment,
                          appointment: [
                            ...tempTableData[
                              sameMedicineInSlotIndex
                            ]?.appointment?.filter(
                              (appItem) => appItem?._id !== dayAppointment?._id
                            ),
                            dayAppointment,
                          ],
                          date: moment(date).format("MM-DD-YYYY"),
                        };
                      } else {
                        tempTableData.push({
                          medicine: medicine?.name,
                          medicationId: medicine?.id,
                          slot: slot,
                          appointment: [dayAppointment],
                          date: moment(date).format("MM-DD-YYYY"),
                        });
                      }
                    }
                  });
                }
              });
            }
          } else {
            slots?.forEach((slot) => {
              tempTableData.push({
                medicine: medicine?.name,
                medicationId: medicine?.id,
                slot: slot,
                appointment: [null],
                date: moment(date).format("MM-DD-YYYY"),
              });
            });
          }
        });
      });

      // tempTableData?.map((alteredData) => {
      //   medicines?.map((med) => med)
      // })
      let newData = [];
      medicines?.map((med) => {
        let filteredDataOnMed = tempTableData?.filter(
          (item) => item?.medicationId == med?.id
        );

        slots?.forEach((slot) => {
          let filteredOnSlot = filteredDataOnMed?.filter(
            (item) => item?.slot == slot
          );
          let appointments = [];
          filteredOnSlot?.map((filteredData) => {
            let filteredSlotApp = _filtered_appointments_on_slot(
              filteredData?.appointment,
              slot
            );
            appointments?.push({
              // appointment: filteredData?.appointment,
              appointment: filteredSlotApp,
              date: filteredData?.date,
            });
          });
          newData.push({ medicine: med, slot, data: appointments });
        });
      });

      // setMarTableData(tempTableData)
      setMarTableData(newData);
    }
  }, [appointments]);

  const medicationStatus = (medications, timSlot) => {
    if (medications?.every((element) => element == null)) {
      return false;
    }

    let notNullMed = medications?.filter((item) => item !== null);

    if (
      notNullMed?.every(
        (element) => element?.medicationType?.toLowerCase() == "missed"
      )
    ) {
      return "missed";
    }

    if (
      notNullMed?.some(
        (element) => element?.medicationType?.toLowerCase() == "taken"
      )
    ) {
      return "taken";
    }

    if (
      notNullMed?.every(
        (element) => element?.medicationType?.toLowerCase() == "refused"
      )
    ) {
      return "refused";
    }

    if (
      notNullMed?.every(
        (element) =>
          element?.medicationType?.toLowerCase() == "out of medication"
      )
    ) {
      return "out";
    }

    if (
      notNullMed?.every(
        (element) => element?.medicationType?.toLowerCase() == "unable to take"
      )
    ) {
      return "unable";
    }

    if (
      notNullMed?.filter(
        (element) => element?.medicationType?.toLowerCase() == "missed"
      )?.length
    ) {
      return "missed";
    }

    if (
      notNullMed?.filter(
        (element) => element?.medicationType?.toLowerCase() == "discontinued"
      )?.length
    ) {
      return "discontinued";
    }

    if (
      notNullMed?.filter(
        (element) => element?.medicationType?.toLowerCase() == "prn"
      )?.length
    ) {
      return "prn";
    }
  };

  const _filtered_appointments_on_slot = (_app, _slot) => {
    let notNullMed = _app?.filter((item) => item !== null);
    const filtered = notNullMed?.filter((obj) =>
      isTimeInSlotFn(_slot, obj?.timeSlot)
    );

    return filtered;
  };

  function isTimeInSlotFn(slot, timeStr) {
    // Helper: Convert time string to minutes (24h format)
    function timeToMinutes(t) {
      const match = t.trim().match(/^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)$/i);
      if (!match) return null;

      let hours = parseInt(match[1], 10);
      const minutes = parseInt(match[2] || "0", 10);
      const period = match[3].toUpperCase();

      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;

      return hours * 60 + minutes;
    }

    // Extract start and end from slot
    const [startStr, endStr] = slot.split("-").map((str) => str.trim());
    const startMinutes = timeToMinutes(startStr);
    const endMinutes = timeToMinutes(endStr);
    const targetMinutes = timeToMinutes(timeStr);

    if (startMinutes === null || endMinutes === null || targetMinutes === null)
      return false;

    // Handle overnight slots (e.g., 10PM - 2AM)
    if (startMinutes <= endMinutes) {
      return targetMinutes >= startMinutes && targetMinutes < endMinutes;
    } else {
      return targetMinutes >= startMinutes || targetMinutes < endMinutes;
    }
  }

  const returnStaffLetters = (medications, isPDF, excelExportTable = false) => {
    const notNullMed = (medications || []).filter((item) => item !== null);

    const seen = new Set();
    const uniqueMeds = [];
    for (const m of notNullMed) {
      if (!m?._id || seen.has(m._id)) continue;
      seen.add(m._id);
      uniqueMeds.push(m);
    }

    const nodes = uniqueMeds.map((item, index) => {
      if (
        item?.staff &&
        item?.medicationType?.toLowerCase() !== "missed" &&
        item?.medicationType?.toLowerCase() !== "discontinued"
      ) {
        const staffId = item?.staff?.id || item?.staff?._id || item?.admin;
        const staffSignature = allSignature?.find(
          (sig) =>
             (sig?.admin && sig.admin?.toString() === staffId?.toString()) ||
            (sig?.staff && sig.staff?.toString() === staffId?.toString())
        );

        if (
          excelExportTable === false &&
          decrypt(staffSignature?.signatureInitials)
        ) {
          return (
            <SignatureInitialsImage
              key={staffId}
              url={decrypt(staffSignature?.signatureInitials)}
              isPDF={isPDF}
              item={item}
            />
          );
        } else if (
          excelExportTable === false &&
          staffSignature?.signatureInitialsText
        ) {
          return (
            <Text fz={20} fw={400} ff="Island Moments" color="#171717">
              {staffSignature?.signatureInitialsText}
            </Text>
          );
        }

        const splittedName = item?.staff?.name?.split(" ");
        const initials = splittedName?.[1]
          ? splittedName[0]?.[0] + splittedName[1]?.[0]
          : splittedName?.[0]?.[0] || "";

        return (
          <span key={staffId + "-init-" + index} style={{ marginRight: 6 }}>
            {initials}
          </span>
        );
      } else {
        return (
          <span key={"dash-" + index} style={{ marginRight: 6 }}>
            -
          </span>
        );
      }
    });

    return nodes;
  };
 
  const downloadPDF = async () => {
    setPDFLoading(true);
    const input = document.getElementById("marPDFReport");

    const decryptedImageUrl = `${decrypt(
      selectedClient?.imageurl
    )}?r=${Math.floor(Math.random() * 100000)}`;

    const imageUrlCheck = decrypt(selectedClient?.imageurl);
    const defaultUrl = "/assets/images/personal.png";
    const img = new Image();
    if (imageUrlCheck == undefined) {
      img.src = defaultUrl;
      // img.src =  defaultImage;
    } else {
      img.src = decryptedImageUrl;
    }
    img.crossOrigin = "anonymous";

    img.onload = async function () {
      if (imageUrlCheck == undefined) {
        await createPDF(input, defaultUrl);
      } else {
        await createPDF(input, decryptedImageUrl);
      }
    };
    img.onerror = function () {
      setPDFLoading(false);
    };
  };

  const createPDF = async (input, image) => {
    const dummyImage = "/assets/images/personal.png";
    const loadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
          } catch (e) {
            resolve(dummyImage);
          }
        };
        img.onerror = () => {
          resolve(dummyImage);
        };
        img.src = src;
      });
    };
    // Calculate the maximum width required by checking internal tables
    // Start with a reasonable minimum width (e.g. 1100px) instead of the full container width
    // This prevents extra whitespace on Windows if the content is small
    let targetWidth = 1100;
    // Check if any internal table is wider than the minimum
    const tables = input.querySelectorAll("table");
    tables.forEach((t) => {
      if (t.scrollWidth > targetWidth) targetWidth = t.scrollWidth;
    });
    // Add a small buffer to ensure margins/padding are included
    targetWidth += 40;
    await html2canvas(input, {
      scale: 2,
      allowTaint: false,
      useCORS: true,
      // Use the calculated targetWidth for both width and windowWidth
      width: targetWidth,
      windowWidth: targetWidth,
      onclone: (clonedDoc) => {
        const imgs = clonedDoc.querySelectorAll("img");
        imgs.forEach((img) => {
          img.style.display = "block";
        });
        // Unlock the main container width in the clone
        const clonedInput = clonedDoc.getElementById("marPDFReport");
        if (clonedInput) {
          clonedInput.style.width = "auto";
          clonedInput.style.minWidth = "fit-content";
          clonedInput.style.maxWidth = "none";
        }
        // Force all scrollable containers (especially tableBody) to be fully visible
        // This "unrolls" the scrollbars so the entire content is rendered
        const scrollables = clonedDoc.querySelectorAll('[class*="tableBody"]');
        scrollables.forEach((s) => {
            s.style.overflow = "visible";
            s.style.overflowX = "visible";
            s.style.width = "auto";
            s.style.maxWidth = "none";
        });
        // Also catch generic scroll containers if class names change
        const divs = clonedDoc.querySelectorAll("div");
        divs.forEach((div) => {
          if (div.style.overflow === "scroll" || div.style.overflowX === "scroll") {
             div.style.overflow = "visible";
             div.style.overflowX = "visible";
             div.style.width = "auto";
          }
        });
        // Ensure tables expand to fit their content
        const clonedTables = clonedDoc.querySelectorAll("table");
        clonedTables.forEach((table) => {
          table.style.width = "auto";
          table.style.minWidth = "fit-content";
          table.style.tableLayout = "auto";
        });
      },
    }).then(async (canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 290; // Keep your original width
      const pageHeight = 210; // Keep your original page height
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;
      const pdf = new jsPDF("landscape", "mm", "a4");
      // Add the first part of the image
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      // Add logo or additional image at the top corner
      const margin = 1;
      const imgSize = 30;
      const validImage = await loadImage(image);
      pdf.addImage(validImage, "PNG", margin, margin, imgSize, imgSize);
      heightLeft -= pageHeight;
      // Add additional pages if the content exceeds one page
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      pdf.save(`${reportName}.pdf`);
      setPDFLoading(false);
    });
  };

  // const createPDF = async (input, image) => {
  //   const dummyImage =
  //     "https://cdn.vectorstock.com/i/1000v/92/16/default-profile-picture-avatar-user-icon-vector-46389216.jpg";

  //   const loadImage = (src) => {
  //     return new Promise((resolve) => {
  //       const img = new Image();
  //       img.crossOrigin = "anonymous";
  //       img.onload = () => {
  //         // draw to canvas to validate it's not corrupt
  //         try {
  //           const canvas = document.createElement("canvas");
  //           canvas.width = img.width;
  //           canvas.height = img.height;
  //           const ctx = canvas.getContext("2d");
  //           ctx.drawImage(img, 0, 0);
  //           const dataURL = canvas.toDataURL("image/png");
  //           resolve(dataURL);
  //         } catch (e) {
  //           resolve(dummyImage);
  //         }
  //       };
  //       img.onerror = () => {
  //         resolve(dummyImage);
  //       };
  //       img.src = src;
  //     });
  //   };
  //   await html2canvas(input, {
  //     scale: 2,
  //     allowTaint: false,
  //     useCORS: true,
  //     onclone: (clonedDoc) => {
  //       const imgs = clonedDoc.querySelectorAll("img");
  //       imgs.forEach((img) => {
  //         img.style.display = "block";
  //       });
  //     },
  //   }).then(async (canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const imgWidth = 250; // Width of the image in the PDF
  //     const pageHeight = 210; // Height of an A4 page in landscape mode in mm
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //     let heightLeft = imgHeight;
  //     let position = 0;

  //     const pdf = new jsPDF("landscape", "mm", "a4");

  //     // Add the first part of the image
  //     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);

  //     // Add logo or additional image at the top corner
  //     const margin = 1;
  //     const imgSize = 30;
  //     const validImage = await loadImage(image);
  //     pdf.addImage(validImage, "PNG", margin, margin, imgSize, imgSize);

  //     heightLeft -= pageHeight;

  //     // Add additional pages if the content exceeds one page
  //     while (heightLeft > 0) {
  //       position = heightLeft - imgHeight;
  //       pdf.addPage();
  //       pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  //       heightLeft -= pageHeight;
  //     }

  //     pdf.save(`${reportName}.pdf`);
  //     setPDFLoading(false);
  //   });
  // };

  // Alternative approach: Split table by month to ensure each month fits on a page

  // const createPDF = async (input, image) => {
  //   const dummyImage = "/assets/images/personal.png";
  //   const loadImage = (src) => {
  //     return new Promise((resolve) => {
  //       const img = new Image();
  //       img.crossOrigin = "anonymous";
  //       img.onload = () => {
  //         try {
  //           const canvas = document.createElement("canvas");
  //           canvas.width = img.width;
  //           canvas.height = img.height;
  //           const ctx = canvas.getContext("2d");
  //           ctx.drawImage(img, 0, 0);
  //           const dataURL = canvas.toDataURL("image/png");
  //           resolve(dataURL);
  //         } catch (e) {
  //           resolve(dummyImage);
  //         }
  //       };
  //       img.onerror = () => {
  //         resolve(dummyImage);
  //       };
  //       img.src = src;
  //     });
  //   };

  //   await html2canvas(input, {
  //     scale: 2,
  //     allowTaint: false,
  //     useCORS: true,
  //     // Only add width to capture full content horizontally
  //     width: input.scrollWidth,
  //     onclone: (clonedDoc) => {
  //       const imgs = clonedDoc.querySelectorAll("img");
  //       imgs.forEach((img) => {
  //         img.style.display = "block";
  //       });

  //       // Ensure the cloned document shows all content width-wise
  //       const clonedInput = clonedDoc.getElementById("marPDFReport");
  //       if (clonedInput) {
  //         clonedInput.style.width = "auto";
  //         clonedInput.style.minWidth = "fit-content";
  //       }

  //       // Also ensure tables don't get compressed
  //       const tables = clonedDoc.querySelectorAll("table");
  //       tables.forEach((table) => {
  //         table.style.width = "auto";
  //         table.style.minWidth = "fit-content";
  //         table.style.tableLayout = "auto";
  //       });
  //     },
  //   }).then(async (canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const imgWidth = 290; // Keep your original width
  //     const pageHeight = 210; // Keep your original page height
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //     let heightLeft = imgHeight;
  //     let position = 0;

  //     const pdf = new jsPDF("landscape", "mm", "a4");

  //     // Add the first part of the image
  //     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);

  //     // Add logo or additional image at the top corner
  //     const margin = 1;
  //     const imgSize = 30;
  //     const validImage = await loadImage(image);
  //     pdf.addImage(validImage, "PNG", margin, margin, imgSize, imgSize);

  //     heightLeft -= pageHeight;

  //     // Add additional pages if the content exceeds one page
  //     while (heightLeft > 0) {
  //       position = heightLeft - imgHeight;
  //       pdf.addPage();
  //       pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  //       heightLeft -= pageHeight;
  //     }

  //     pdf.save(`${reportName}.pdf`);
  //     setPDFLoading(false);
  //   });
  // };

  function isTimeWithinSlot(slot, time) {
    // Helper to parse time like "6AM" or "06:30 AM" into a Date object (today's date)
    const parseTime = (str) => {
      const today = new Date();
      const [hours, minutes, period] = str
        ?.match(/(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i)
        .slice(1);
      let h = parseInt(hours, 10);
      const m = parseInt(minutes || "0", 10);

      if (period.toUpperCase() === "PM" && h !== 12) h += 12;
      if (period.toUpperCase() === "AM" && h === 12) h = 0;

      const date = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        h,
        m
      );
      return date;
    };

    const [startStr, endStr] = slot?.split("-")?.map((s) => s?.trim());
    const startTime = parseTime(startStr);
    const endTime = parseTime(endStr);
    const checkTime = parseTime(time);

    return checkTime >= startTime && checkTime <= endTime;
  }
  return (
    <>
      <Modal
        centered
        size={1720}
        shadow="md"
        radius={"lg"}
        zIndex={1000}
        opened={opened}
        onClose={onClose}
        styles={{
          header: { width: "1720px" },
        }}
        overlayProps={{ blur: 3 }}
      >
        <>
          <Box className={classes.exportBtn}>
            <ActionIcon ml={15} disabled={loading} loading={loading}>
              <ReactHTMLTableToExcel
                table="marTableExport"
                loading={loading}
                disabled={loading}
                sheet={reportName}
                id="test-table-xls-button"
                filename={`${reportName}`}
                className="download-table-xls-button"
                buttonText={
                  <ActionIcon>
                    <img src="/assets/images/xlsDowload.png" alt="" />
                  </ActionIcon>
                }
              />
            </ActionIcon>

            <ActionIcon
              ml={15}
              loading={pdfLoading || loading}
              disabled={loading}
              onClick={downloadPDF}
            >
              <img src="/assets/images/pdf.png" alt="" />
            </ActionIcon>
          </Box>
          <MarTableComponent
            image={image}
            loading={loading}
            daysArray={daysArray}
            monthValue={monthValue}
            datesArray={datesArray}
            marTableData={marTableData}
            selectedClient={selectedClient}
            medicationStatus={medicationStatus}
            returnStaffLetters={returnStaffLetters}
            staffList={staffList}
          />

          <div style={{ display: "none" }}>
            <MarTableComponent
              image={image}
              loading={loading}
              daysArray={daysArray}
              monthValue={monthValue}
              datesArray={datesArray}
              marTableData={marTableData}
              selectedClient={selectedClient}
              medicationStatus={medicationStatus}
              returnStaffLetters={returnStaffLetters}
              staffList={staffList}
              excelExportTable={true}
            />
          </div>
        </>
      </Modal>

      <PDFMarTableComponent
        image={image}
        loading={loading}
        datesArray={datesArray}
        monthValue={monthValue}
        marTableData={marTableData}
        selectedClient={selectedClient}
        medicationStatus={medicationStatus}
        returnStaffLetters={returnStaffLetters}
        staffList={staffList}
        allSignature={allSignature}
        isPDF={true}
      />
    </>
  );
};

const MarTableComponent = ({
  image,
  loading,
  daysArray,
  datesArray,
  monthValue,
  marTableData,
  selectedClient,
  medicationStatus,
  returnStaffLetters,
  staffList,
  excelExportTable = false,
}) => {
  const { classes } = useStyles();
  const { allSignature } = useSelector((state) => state?.signature);

  // useEffect(() => {
  //   getAllSignatures();
  // }, []);

  return (
    <Box className={classes.tableContainer}>
      {loading ? (
        <Box className={classes.loaderContainer}>
          <TableLoader />
        </Box>
      ) : (
        <>
          <Box className={classes.tableHeader}>
            <Box className={classes.clientDetails}>
              <Avatar
                alt="logo"
                src={image}
                size={"150px"}
                crossOrigin="anonymous"
                onError={() => {
                  "https://via.placeholder.com/150x150.png?text=No+Image+Found";
                }}
              />

              <Box className={classes.clientInfo}>
                <Table withBorder withColumnBorders>
                  <tbody>
                    <tr>
                      <td className={classes.bgCellColor}>
                        <Text fw={700} w={"100px"}>
                          Client Name:
                        </Text>
                      </td>
                      <td>
                        <Text w={"100px"}>{selectedClient?.name}</Text>{" "}
                      </td>
                    </tr>
                    <tr>
                      <td className={classes.bgCellColor}>
                        <Text fw={700}>Client DOB</Text>
                      </td>
                      <td>
                        {moment(selectedClient?.form1?.dob).format(
                          "MM/DD/YYYY"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className={classes.bgCellColor}>
                        <Text fw={700}>Report Month</Text>
                      </td>
                      <td>
                        {monthValue
                          ?.map((item) =>
                            moment(item).isValid()
                              ? moment(item).format("MMM YYYY")
                              : ""
                          )
                          .join(" - ")}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Box>

              <Box className={classes.cuationsBox}>
                <div
                  style={{
                    maxWidth: "900px",
                    width: "100%",
                    overflowX: "auto",
                  }}
                >
                  <Table withBorder withColumnBorders>
                    <tbody>
                      <tr>
                        <td className={classes.bgCellColor}>
                          <Text fw={700} w={"100px"}>
                            Staff Name:
                          </Text>
                        </td>
                        {staffList?.map((_s) => (
                          <td>
                            <Text w={"100px"}>{_s?.name}</Text>
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td className={classes.bgCellColor}>
                          <Text fw={700} w={"100px"}>
                            Staff Initials:
                          </Text>
                        </td>
                        {staffList?.map((_s) => {
                          const signatureFind = allSignature?.find(
                            ({ staff, admin }) =>
                              (staff && staff === _s.id) || (admin && admin === _s.id)
                          );
                          return (
                            <td>
                              {decrypt(signatureFind?.signatureInitials) ? (
                                <img
                                  src={decrypt(
                                    signatureFind?.signatureInitials
                                  )}
                                  width={100}
                                />
                              ) : signatureFind?.signatureInitialsText ? (
                                <Text
                                  fz={20}
                                  fw={400}
                                  ff="Island Moments"
                                  color="#171717"
                                >
                                  {signatureFind?.signatureInitialsText}
                                </Text>
                              ) : (
                                <Text w={"100px"}>{_s?.initial}</Text>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                      <tr>
                        <td className={classes.bgCellColor}>
                          <Text fw={700} w={"100px"}>
                            Staff Sign:
                          </Text>
                        </td>
                        {staffList?.map((_s) => (
                          <td key={_s.id}>
                            {(() => {
                              const sigObj = allSignature?.find(
                                ({ staff, admin }) =>
                                  (staff && staff === _s.id) || (admin && admin === _s.id)
                              );
                              const sigUrl =
                                decrypt(sigObj?.signature) ||
                                decrypt(sigObj?.signatureImage);
                              return sigUrl ? (
                                <img src={sigUrl} width="250px" />
                              ) : sigObj?.signatureText ? (
                                <Text
                                  fz={28}
                                  fw={400}
                                  ff="Island Moments"
                                  color="#171717"
                                >
                                  {sigObj?.signatureText}
                                </Text>
                              ) : (
                                "None"
                              );
                            })()}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </Table>
                </div>

                <Cuations />
                <Flex gap={50} align="flex-start" justify="center">
                  <Flex
                    direction="column"
                    align="center"
                    justify="center"
                    sx={{ flex: 1 }}
                  >
                    <Text fz={32} fw={700} ta="center">
                      {/* Special Healthcare LLC */}
                      {selectedClient?.facilityId
                        ? selectedClient?.facilityId
                            ?.map((item) => item?.name)
                            .join(", ")
                        : ""}
                    </Text>
                    <Text fz={26} fw={600} ta="center">
                      Medication Administration Record (MAR)
                    </Text>
                    <Text fz={20} fw={500}>
                      {monthValue
                        ?.map((item) =>
                          moment(item).isValid()
                            ? moment(item).format("MMM YYYY")
                            : ""
                        )
                        .join(" - ")}
                    </Text>
                  </Flex>
                  <img
                    src="/assets/images/logo2.png"
                    alt="Logo"
                    style={{ width: "10%", height: "auto" }}
                  />
                </Flex>
              </Box>
            </Box>
          </Box>
          <Box className={classes.tableBody}>
            <Table
              id={excelExportTable ? "marTableExport" : "marTable"}
              withColumnBorders
            >
              {/* this thead content only show on excel sheet not on modal */}
              <thead style={{ display: "none" }}>
                <tr>
                  <td>
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={image}
                        width="50"
                        height="50"
                        style={{
                          display: "block",
                          objectFit: "cover",
                        }}
                        alt="logo"
                        crossOrigin="anonymous"
                      />
                    </div>
                  </td>
                  <td className={classes.dateCellsContent}>
                    {/* {" "}
                    <Avatar
                      style={{ width: "50px", height: "50px" }}
                      w={50}
                      h={50}
                      size={50}
                      alt="logo"
                      src={image}
                      crossOrigin="anonymous"
                    ></Avatar> */}

                    <td></td>
                    {/* <img
                      src={image}
                      width="100"
                      height="100"
                      alt="logo"
                      crossOrigin="anonymous"
                    /> */}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={{ background: "#4fa80d" }}>
                    <Text fw={700} fz={14} w={200}>
                      Taken
                    </Text>
                  </td>
                  <td style={{ background: "#eb7a74" }}>
                    <Text fw={700} fz={14} w={200}>
                      Missed
                    </Text>
                  </td>
                  <td style={{ background: "#c7daf5" }}>
                    <Text fw={700} fz={14} w={200}>
                      Refused
                    </Text>
                  </td>
                  <td style={{ background: "#979797" }}>
                    <Text fw={700} fz={14} w={200}>
                      Upcoming
                    </Text>
                  </td>
                  <td style={{ background: "#feff80" }}>
                    <Text fw={700} fz={14} w={200}>
                      Unable to Take
                    </Text>
                  </td>
                  <td style={{ background: "#000000", color: "#ffffff" }}>
                    <Text fw={700} fz={14} w={200}>
                      Out of Medication
                    </Text>
                  </td>

                  <td style={{ background: "#8B4513", color: "#ffffff" }}>
                    <Text fw={700} fz={14} w={200}>
                      Discontinued
                    </Text>
                  </td>

                  <td style={{ background: "#a03399" }}>
                    <Text fw={700} fz={14} w={200}>
                      PRN
                    </Text>
                  </td>
                  <td></td>
                  <td>
                    {" "}
                    <Avatar
                      w={50}
                      h={50}
                      alt="logo"
                      src={
                        "https://ogiso-bucket.s3.us-east-2.amazonaws.com/logo.png"
                      }
                      size={"50"}
                    ></Avatar>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={{ background: "#b7b7b7" }}>
                    <Text fw={700} w={"100px"}>
                      Client Name:
                    </Text>
                  </td>
                  <td>
                    <Text w={"100px"}>{selectedClient?.name}</Text>{" "}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={{ background: "#b7b7b7" }}>
                    <Text fw={700}>Client DOB</Text>
                  </td>
                  <td>
                    {/* <Text w={"100px"}>{selectedClient?.form1?.dob}</Text> */}
                    {moment(selectedClient?.form1?.dob).format("MM/DD/YYYY")}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={{ background: "#b7b7b7" }}>
                    <Text fw={700}>Report Months</Text>
                  </td>
                  <td colSpan={3}>
                    {monthValue
                      ?.map((item) =>
                        moment(item).isValid()
                          ? moment(item).format("MMM YYYY")
                          : ""
                      )
                      .join(" - ")}
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={{ background: "#b7b7b7" }}>
                    <Text fw={700}>Staff Name</Text>
                  </td>
                  {staffList?.map((_s) => (
                    <Text>
                      <td colSpan={3}>{_s?.name}</td>
                    </Text>
                  ))}
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={{ background: "#b7b7b7" }}>
                    <Text fw={700}>Staff Initials:</Text>
                  </td>
                  {staffList?.map((_s) => {
                    const signatureFind = allSignature?.find(
                      ({ staff, admin }) => (staff && staff === _s.id) || (admin && admin === _s.id)
                    );
                    return (
                      <td colSpan={3}>
                        {decrypt(signatureFind?.signatureInitials) ? (
                          <img
                            src={decrypt(signatureFind?.signatureInitials)}
                            width={40}
                            height={20}
                            style={{
                              display: "block",
                              objectFit: "cover",
                              maxWidth: "100%",
                              maxHeight: "100%",
                            }}
                            crossOrigin="anonymous"
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.style.display = "none";
                            }}
                          />
                        ) : signatureFind?.signatureInitialsText ? (
                          <Text
                            fz={20}
                            fw={400}
                            ff="Island Moments"
                            color="#171717"
                          >
                            {signatureFind?.signatureInitialsText}
                          </Text>
                        ) : (
                          _s?.initial
                        )}
                      </td>
                    );
                  })}
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td colSpan={2}>
                    <Text fz={32} fw={700} w={400}>
                      {/* Special Healthcare LLC */}
                      {selectedClient?.facilityId
                        ? selectedClient?.facilityId
                            ?.map((item) => item?.name)
                            .join(", ")
                        : ""}
                    </Text>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td colSpan={3}>
                    <Text fz={26} fw={600} w={500}>
                      Medication Administration Record (MAR)
                    </Text>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td colSpan={3}>
                    <Text fz={20} fw={500} w={300}>
                      {monthValue
                        ?.map((item) =>
                          moment(item).isValid()
                            ? moment(item).format("MMM YYYY")
                            : ""
                        )
                        .join(" - ")}
                    </Text>
                  </td>
                </tr>
                <tr></tr>
              </thead>

              <tbody>
                <tr
                  className={classes.dateCells}
                  style={{ background: "#d0e0e3" }}
                >
                  <td className={classes.dateCellsContent}></td>
                  <td className={classes.dateCellsContent}></td>
                  {daysArray?.map((day, index) => (
                    <td key={index} className={classes.dateCellsContent}>
                      <Text>{day}</Text>
                    </td>
                  ))}
                </tr>
                <tr
                  className={classes.dateCells}
                  style={{ background: "#d0e0e3" }}
                >
                  <td className={classes.dateCellsContent}></td>
                  <td className={classes.dateCellsContent}></td>
                  {datesArray?.map((date, index) => (
                    <td key={index} className={classes.dateCellsContent}>
                      <Text>{date?.format("MM/DD/YYYY")}</Text>
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>Medication</td>
                  <td>Time</td>
                  {datesArray?.map((date, index) => (
                    <td key={index}>
                      <Text>{date?.format("DD")}</Text>
                    </td>
                  ))}
                  {/* {marTableData[0]?.data?.map((v, zerothIndexs) => (
                    <td>{zerothIndexs + 1}</td>
                  ))} */}
                </tr>
                {marTableData?.length &&
                  marTableData?.map((marItem, marIndex) => (
                    <>
                      {marIndex % 6 === 0 && (
                        <tr>
                          {/* <td rowSpan={marIndex == 0 ? 7 : 6} className={classes.bgTitleColor}> */}
                          <td
                            rowSpan={7}
                            className={classes.bgTitleColor}
                            style={{
                              background: "#ffff00",
                              border: "1px solid #000000",
                            }}
                          >
                            <Box className={classes.medTitleCell}>
                              <Text fz={22} fw={600}>
                                {marItem?.medicine?.name}
                              </Text>
                              <Text>{marItem?.medicine?.instruction}</Text>
                              {/* <Text>Scheduled: 8AM, 6PM</Text> */}
                            </Box>
                          </td>
                        </tr>
                      )}

                      <tr>
                        <td>
                          <Text w={"100px"}>{marItem?.slot}</Text>
                        </td>
                        {
                          // marItem?.data?.map((item) => <td>{item?.appointment?.includes(null) ? "-" : "found"}</td>)
                          marItem?.data?.map((item) =>{ 
                            return (
                            <td
                              style={{
                                background:
                                  medicationStatus(item?.appointment) ==
                                  "missed"
                                    ? "#eb7a74"
                                    : medicationStatus(
                                        item?.appointment,
                                        marItem?.slot
                                      ) == "taken"
                                    ? "#4fa80d"
                                    : medicationStatus(
                                        item?.appointment,
                                        marItem?.slot
                                      ) == "discontinued"
                                    ? "#8B4513"
                                    : medicationStatus(
                                        item?.appointment,
                                        marItem?.slot
                                      ) == "out"
                                    ? "#000"
                                    : medicationStatus(item?.appointment) ==
                                      "refused"
                                    ? "#c7daf5"
                                    : medicationStatus(item?.appointment) ==
                                      "unable"
                                    ? "#feff80"
                                    : medicationStatus(item?.appointment) ==
                                      "prn"
                                    ? "#a03399"
                                    : "",

                                color:
                                  medicationStatus(item?.appointment) == "out"
                                    ? "#fff"
                                    : "",
                              }}
                            >
                              {medicationStatus(item?.appointment) == false ? (
                                ""
                              ) : medicationStatus(item?.appointment) ==
                                "missed" ? (
                                "-"
                              ) : medicationStatus(item?.appointment) ==
                                "refused" ? (
                                returnStaffLetters(
                                  item?.appointment,
                                  undefined,
                                  excelExportTable
                                )
                              ) : medicationStatus(item?.appointment) ==
                                "out" ? (
                                returnStaffLetters(
                                  item?.appointment,
                                  undefined,
                                  excelExportTable
                                )
                              ) : medicationStatus(item?.appointment) ==
                                "unable" ? (
                                returnStaffLetters(
                                  item?.appointment,
                                  undefined,
                                  excelExportTable
                                )
                              ) : medicationStatus(
                                  item?.appointment,
                                  marItem?.slot
                                ) == "taken" ? (
                                returnStaffLetters(
                                  item?.appointment,
                                  undefined,
                                  excelExportTable
                                )
                              ) : medicationStatus(
                                  item?.appointment,
                                  marItem?.slot
                                ) == "discontinued" ? (
                                <Text>D/C</Text>
                              ) : medicationStatus(
                                  item?.appointment,
                                  marItem?.slot
                                ) == "prn" ? (
                                returnStaffLetters(
                                  item?.appointment,
                                  undefined,
                                  excelExportTable
                                )
                              ) : (
                                ""
                              )}
                            </td>
                          )})
                        }
                      </tr>
                    </>
                  ))}
              </tbody>
            </Table>
          </Box>
        </>
      )}
    </Box>
  );
};

const PDFMarTableComponent = ({
  image,
  loading,
  datesArray,
  monthValue,
  marTableData,
  selectedClient,
  medicationStatus,
  returnStaffLetters,
  staffList,
  allSignature,
  isPDF,
}) => {
  const { classes } = useStyles();

  const ref_months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let startMonth = ref_months?.findIndex(
    (item) =>
      item?.toLowerCase() == moment(monthValue[0])?.format("MMM")?.toLowerCase()
  );
  let endMonth = ref_months?.findIndex(
    (item) =>
      item?.toLowerCase() ==
      moment(monthValue[monthValue?.length - 1])
        ?.format("MMM")
        ?.toLowerCase()
  );

  let filteredMonths = ref_months?.slice(
    startMonth,
    // startMonth == endMonth ? startMonth + 1 : endMonth
    endMonth + 1
  );

  return (
    <Box className={classes.forPdfBox} id={"marPDFReport"}>
      {loading ? (
        <Box className={classes.loaderContainer}>
          <TableLoader />
        </Box>
      ) : (
        <>
          {/* Table Header */}
          <Box
            className={classes.tableHeader}
            style={{
              display: "flex",
              alignItems: "start",
              justifyContent: "flex-start",
              width: "100%",
            }}
          >
            <Box className={classes.clientDetails}>
              {/* <Avatar
                w={250}
                h={250}
                alt="logo"
                // src={image}
                src={`${image}?r=${Math.floor(Math.random() * 100000)}`}
                size={"250"}
                crossOrigin="anonymous"
              ></Avatar> */}
              {/* <img
                alt="logo"
                src={image || null}
                width={"250px"}
                height={"250px"}
                crossOrigin="anonymous"
                onError={(e) => {
                  e.currentTarget.src =
                    "https://via.placeholder.com/250x250.png?text=No+Image+Found";
                }}
              /> */}
              <Box w={250}></Box>
              <Box className={classes.clientInfo}>
                <Table withBorder withColumnBorders borderColor="red">
                  <tbody>
                    <tr>
                      <td className={classes.bgCellColor}>
                        <Text fw={700} w={"100px"}>
                          Client Name:
                        </Text>
                      </td>
                      <td>
                        <Text w={"100px"}>{selectedClient?.name}</Text>{" "}
                      </td>
                    </tr>
                    <tr>
                      <td className={classes.bgCellColor}>
                        <Text fw={700}>Client DOB</Text>
                      </td>
                      <td>
                        {moment(selectedClient?.form1?.dob).format(
                          "MM/DD/YYYY"
                        )}
                      </td>
                    </tr>
                    {/* <tr>
                      <td className={classes.bgCellColor}>
                        <Text fw={700}>Report Month</Text>
                      </td>
                      <td>{month}</td>
                    </tr> */}
                  </tbody>
                </Table>
              </Box>
            </Box>

            <Box className={classes.signatureBoxPDF}>
              <Table withBorder withColumnBorders>
                <tbody>
                  <tr>
                    <td className={classes.bgCellColor}>
                      <Text fw={700} w={"100px"}>
                        Staff Name:
                      </Text>
                    </td>
                    {staffList?.map((_s) => (
                      <td>
                        <Text w={"100px"}>{_s?.name}</Text>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <td className={classes.bgCellColor}>
                      <Text fw={700} w={"100px"}>
                        Staff Initials:
                      </Text>
                    </td>
                    {staffList?.map((_s) => {
                      const signatureFind = allSignature?.find(
                        ({ staff, admin }) => (staff && staff === _s.id) || (admin && admin === _s.id)
                      );
                      return (
                        <td>
                          {decrypt(signatureFind?.signatureInitials) ? (
                            <img
                              src={decrypt(signatureFind?.signatureInitials)}
                              width={100}
                              alt="Initials"
                              crossOrigin="anonymous"
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.style.display = "none";
                              }}
                            />
                          ) : signatureFind?.signatureInitialsText ? (
                            <Text
                              fz={20}
                              fw={400}
                              ff="Island Moments"
                              color="#171717"
                            >
                              {signatureFind?.signatureInitialsText}
                            </Text>
                          ) : (
                            <Text w={"100px"}>{_s?.initial}</Text>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                  <tr>
                    <td className={classes.bgCellColor}>
                      <Text fw={700} w={"100px"}>
                        Staff Sign:
                      </Text>
                    </td>
                    {staffList?.map((_s) => (
                      <td key={_s.id}>
                        {(() => {
                          const sigObj = allSignature?.find(
                            ({ staff, admin }) =>
                              (staff && staff === _s.id) || (admin && admin === _s.id)
                          );
                          const sigUrl =
                            decrypt(sigObj?.signature) ||
                            decrypt(sigObj?.signatureImage);
                          return sigUrl ? (
                            <img
                              src={sigUrl}
                              width="250px"
                              crossOrigin="anonymous"
                              style={{
                                display: "block",
                              }}
                              alt="Signature"
                            />
                          ) : sigObj?.signatureText ? (
                            <Text
                              fz={28}
                              fw={400}
                              ff="Island Moments"
                              color="#171717"
                            >
                              {sigObj?.signatureText}
                            </Text>
                          ) : (
                            "None"
                          );
                        })()}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </Table>
            </Box>
          </Box>
          <Box className={classes.cuationBoxPDF}>
            <Cuations />
          </Box>
          <Flex gap={50} align="flex-start" justify="center">
            <Flex direction="column" align="center" justify="center">
              <Text fz={32} fw={700} align="center">
                {selectedClient?.facilityId
                  ? selectedClient?.facilityId
                      ?.map((item) => item?.name)
                      .join(", ")
                  : ""}
              </Text>
              <Text fz={26} fw={600} style={{ margin: "auto" }}>
                Medication Administration Record (MAR)
              </Text>
            </Flex>
            <img
              src="/assets/images/logo2.png"
              alt="Logo"
              style={{ width: "10%", height: "auto" }}
            />
          </Flex>
          {filteredMonths?.map((month, monthIndex) => (
            <Box key={monthIndex} mb={30}>
              <Box
                className={classes.reportMonth}
                sx={{ paddingRight: monthIndex == 0 ? "calc(10% + 50px)" : 0 }}
              >
                <Text fw={700}>Report Month: </Text>
                <Text fz={20} fw={500} align="center">
                  {month}
                </Text>
              </Box>

              {/* Table Body */}
              <Box className={classes.tableBody}>
                <Table id={`marTable-${monthIndex}`} withColumnBorders>
                  <thead>
                    <tr
                      className={classes.dateCells}
                      style={{ background: "#d0e0e3" }}
                    >
                      <td className={classes.dateCellsContent}></td>
                      <td className={classes.dateCellsContent}></td>
                      {/* {daysArray
                        ?.map((day, index) => (
                          <td key={index} className={classes.dateCellsContent}>
                            <Text>{day}</Text>
                          </td>
                        ))} */}
                      {datesArray
                        ?.filter(
                          (item) =>
                            moment(item)?.format("MMM")?.toLowerCase() ==
                            month?.toLowerCase()
                        )
                        ?.map((date, index) => (
                          <td key={index} className={classes.dateCellsContent}>
                            <Text>{date.format("ddd")}</Text>{" "}
                            {/* Change here to 'ddd' for day of the week */}
                          </td>
                        ))}
                    </tr>
                    <tr
                      className={classes.dateCells}
                      style={{ background: "#d0e0e3" }}
                    >
                      <td className={classes.dateCellsContent}></td>
                      <td className={classes.dateCellsContent}></td>
                      {datesArray
                        ?.filter(
                          (item) =>
                            moment(item)?.format("MMM")?.toLowerCase() ==
                            month?.toLowerCase()
                        )
                        ?.map((date, index) => (
                          <td key={index} className={classes.dateCellsContent}>
                            <Text>{date.format("MM/DD/YYYY")}</Text>
                          </td>
                        ))}
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Medication</td>
                      <td>Time</td>
                      {datesArray
                        ?.filter(
                          (item) =>
                            moment(item)?.format("MMM")?.toLowerCase() ==
                            month?.toLowerCase()
                        )
                        ?.map((date, index) => (
                          <td key={index} className={classes.dateCellsContent}>
                            <Text>{index + 1}</Text>
                          </td>
                        ))}
                    </tr>

                    {marTableData
                      // ?.filter((marItem) => {
                      //   // Assuming you have a date field in each marItem, you can filter it here based on the month
                      //   const marDate = moment(marItem?.date);
                      //   return marDate.isSame(month, "month");
                      // })
                      ?.map((marItem, marIndex) => (
                        <>
                          {marIndex % 6 === 0 && (
                            <tr>
                              <td
                                rowSpan={7}
                                className={classes.bgTitleColor}
                                style={{
                                  background: "#ffff00",
                                  border: "1px solid #000000",
                                }}
                              >
                                <Box className={classes.medTitleCell}>
                                  <Text fz={22} fw={600}>
                                    {marItem?.medicine?.name}
                                  </Text>
                                  <Text>{marItem?.medicine?.instruction}</Text>
                                </Box>
                              </td>
                            </tr>
                          )}

                          <tr>
                            <td>
                              <Text w={"100px"}>{marItem?.slot}</Text>
                            </td>
                            {marItem?.data
                              ?.filter(
                                (item) =>
                                  moment(item?.date)
                                    ?.format("MMM")
                                    ?.toLowerCase() == month?.toLowerCase()
                              )
                              ?.map((item) => (
                                <td
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                    background:
                                      medicationStatus(item?.appointment) ===
                                      "missed"
                                        ? "#eb7a74"
                                        : medicationStatus(
                                            item?.appointment,
                                            marItem?.slot
                                          ) === "taken"
                                        ? "#4fa80d"
                                        : medicationStatus(
                                            item?.appointment
                                          ) === "out"
                                        ? "#000"
                                        : medicationStatus(
                                            item?.appointment
                                          ) === "refused"
                                        ? "#c7daf5"
                                        : medicationStatus(
                                            item?.appointment
                                          ) === "unable"
                                        ? "#feff80"
                                        : medicationStatus(item?.appointment) ==
                                          "discontinued"
                                        ? "#8B4513"
                                        : medicationStatus(item?.appointment) ==
                                          "prn"
                                        ? "#a03399"
                                        : "",
                                    color:
                                      medicationStatus(item?.appointment) ===
                                      "out"
                                        ? "#fff"
                                        : "",
                                  }}
                                >
                                  {medicationStatus(item?.appointment) ===
                                  false ? (
                                    ""
                                  ) : medicationStatus(item?.appointment) ===
                                    "missed" ? (
                                    "-"
                                  ) : medicationStatus(item?.appointment) ===
                                    "refused" ? (
                                    returnStaffLetters(item?.appointment, isPDF)
                                  ) : medicationStatus(item?.appointment) ===
                                    "out" ? (
                                    returnStaffLetters(item?.appointment, isPDF)
                                  ) : medicationStatus(item?.appointment) ===
                                    "unable" ? (
                                    returnStaffLetters(item?.appointment, isPDF)
                                  ) : medicationStatus(item?.appointment) ===
                                    "taken" ? (
                                    returnStaffLetters(item?.appointment, isPDF)
                                  ) : medicationStatus(item?.appointment) ===
                                    "discontinued" ? (
                                    <Text>D/C</Text>
                                  ) : medicationStatus(
                                      item?.appointment,
                                      marItem?.slot
                                    ) == "prn" ? (
                                    returnStaffLetters(
                                      item?.appointment,
                                      marItem?.slot
                                    )
                                  ) : (
                                    ""
                                  )}
                                </td>
                              ))}
                          </tr>
                        </>
                      ))}
                  </tbody>
                </Table>
              </Box>
            </Box>
          ))}
        </>
      )}
    </Box>
  );
};

const useStyles = createStyles((theme) => ({
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "70vh",
  },
  reportMonth: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
  },
  greenBox: {
    width: "15px",
    height: "15px",
    background: "#4fa80d",
  },
  exportBtn: {
    display: "flex",
    justifyContent: "end",
    padding: "1rem",
    alignItems: "center",
    gap: "1rem",
    width: "1700px",
  },
  tableContainer: {
    border: "1px solid #EDEDED",
    width: "1700px",
  },
  forPdfBox: {
    width: "1920px",
    position: "absolute",
    left: "-9999px",
  },
  clientDetails: {
    display: "flex",
    alignItems: "start",
    gap: ".5rem",
    justifyContent: "start",
    padding: "1rem",
  },
  cuationsBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: ".5rem",
    flexDirection: "column",
  },
  cuationBoxPDF: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
  },
  signatureBoxPDF: {
    display: "flex",
    alignItems: "start",
    gap: ".5rem",
    justifyContent: "start",
    flexDirection: "column",
  },
  marTextLogoBoxPDF: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
  },
  tableBodyBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    gap: ".5rem",
    width: "100%",
  },
  bgCellColor: {
    backgroundColor: "#b7b7b7",
  },
  dateCells: {
    backgroundColor: "#d0e0e3",
    border: "unset",
  },
  bgTitleColor: {
    background: "#ffff00",
    width: "200px",
  },
  medTitleCell: {
    width: "200px",
  },
  tableHeader: {
    width: "100%",
  },
  tableBody: {
    overflowX: "scroll",
    "& table": {
      width: "500px",
      "& tr:nth-child(1) td": {
        fontSize: "12px !important",
        fontWeight: "400 !important",
        textAlign: "center",
      },
      "& tr:nth-child(2) td": {
        fontSize: "10px !important",
        fontWeight: "300 !important",
        textAlign: "center",
      },
    },
  },
  dateCellsContent: {
    borderTop: "none !important",
    borderRight: "none !important",
  },
}));

export default MarViewReportModal;
